/**
 * /app/$tenantSlug/performance/reviews/new — legacy redirect →
 * /performance/cycles/new (2026-10 QA). Creating a cycle is HR cycle
 * administration on the RUN surface; under /performance/reviews it flipped
 * the sidebar to the Inbox surface. Old links / bookmarks land on the new
 * page.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/performance/reviews/new",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/$tenantSlug/performance/cycles/new",
      params: { tenantSlug: params.tenantSlug },
    });
  },
});
